import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

interface MileageBarChartProps {
  months: string[];
  datos: { year: number; month: number; odometry: number }[];
  height?: number;
  tooltipLabel?: string;
}

export const MileageBarChart: React.FC<MileageBarChartProps> = ({ months, datos, height = 280, tooltipLabel = 'odometry' }) => {
  // Mapear datos para que el eje X sea el nombre del mes
  const chartData = months.map((month, idx) => {
    const d = datos.find(e => e.month === idx + 1);
    return {
      name: month,
      odometry: d ? parseFloat((d.odometry / 1000).toFixed(2)) : 0
    };
  });

  return (
    <div className="w-full">
      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={chartData} margin={{ top: 16, right: 24, left: 8, bottom: 16 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            height={48}
            tick={props => {
              const { x, y, payload } = props;
              return (
                <text
                  x={x}
                  y={y + 16}
                  transform={`rotate(-35,${x},${y + 16})`}
                  fontSize={12}
                  textAnchor="end"
                  fill="#334155"
                  fontWeight={'bold'}
                >
                  {payload.value}
                </text>
              );
            }}
          />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip formatter={(value: any) => [`${value} Km`, tooltipLabel]} />
          <Bar dataKey="odometry" fill="#38bdf8" radius={[6, 6, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MileageBarChart;
